<template>
  <div class="backgroundContacto" id="background9">
    <div class="transbox" id="transbox9">
      <h1 class="pulse">Contacto</h1>
      <br>
      <p>Teléfono: 987 259 549</p>

      <p>Correo: <a href="mailto:administracion@lg-legitrans.com">administracion@lg-legitrans.com</a></p> 
      <br>
      <h2>Oficinas</h2>
      <br>
      <p>Sede Operativa y Oficinas Centrales:	PG. IND. de León, PARC. M-68	24231 (Onzonilla) León</p>
      <p>Consejo de Administración:	CL Guzmán el Bueno 133, EDIF. Britania	28003 Madrid</p>

      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2939.763667135295!2d-5.5840302845379854!3d42.53907477917527!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd37857338d7de51%3A0x12842537a1ace466!2sLegitrans!5e0!3m2!1ses!2ses!4v1600429218950!5m2!1ses!2ses" width="450" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0" ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contacto',
  props: {
    msg: String
  },
  created(){
    window.addEventListener("scroll", function () {
      if (document.querySelector("#background9").getBoundingClientRect().top < this.window.innerHeight){
        document.querySelector("#transbox9").classList.add("animation")
      }  
    })
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
li{
  margin: 0 40px 0;
}
a {
  color: #42b983;
}
iframe{
  margin-top: 50px;
  margin-right: 25%;
  margin-left: 25%;
}
div.backgroundContacto {
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 5px;
  padding-bottom: 5px;
  min-width: 800px;
}

div.transbox {
  margin: 30px;
  padding : 5%;
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  background: linear-gradient(300deg, rgb(27, 94, 32, 0.8) 0%, rgba(144,238,144,0.8) 50%, rgb(255, 255, 255, 0.8) 100%);
  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
  border-radius: 15px;
  min-width: 750px;
}
iframe{
  margin-left: 25%;
  margin-right: 25%;
  width: 50%;
}
.animation{
  animation-name: opacity1;
  animation-duration: 1000ms;
  transform-origin:70% 70%;
  animation-iteration-count: initial;
  animation-timing-function: linear;
}

@keyframes opacity1 {
  0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 0.8;
    }
}
.pulse:hover {
    animation-name: pulse_animation1;
    animation-duration: 5000ms;
    transform-origin:0% 70%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes pulse_animation1 {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}
div {
  font-size: 30px;
}
</style>